var cellMap = {
  fiscalYearClass: 'fiscal_year',
  projectTitleClass: 'project_title',
  startTerminusClass: 'start_terminus',
  endTerminusClass: 'end_terminus',
  leadAgencyClass: 'lead_agency',
  allAgenciesClass: 'all_agencies',
  fundTypeClass: 'fund_type',
  federalFundingClass: 'federal_funding',
  stateFundingClass: 'state_funding',
  leadAgencyFundingClass: 'lead_agency_funding',
  otherAgencyFundingClass: 'other_agency_funding',
  totalCostClass: 'total_cost',
  descriptionClass: 'description',
  projectCategoryClass: 'project_category',
  nonInfrastructureClass: 'non_infrastructure',
  multiAgencyClass: 'multi_agency',
  advancedConstructionClass: 'advanced_construction',
  changeAgencyClass: 'change_agency'
}

function tipFilter(features: any) {
  // All rows without change_type, Amendment with status of Approved,
  // and all Modifications, and change_type that has empty string
  let filteredFeatures = features.filter((feature) => {
    let changeType = feature['properties']['change_type'];
    let status = feature['properties']['status'];

    if (changeType === null || changeType === undefined) {
      return true;
    }
    return (
    (changeType.toLowerCase() === '') ||
    (changeType.toLowerCase() === 'modification') ||
    (changeType.toLowerCase() === 'amendment' &&
     status.toLowerCase() === 'approved')
    )}
  )
  return filteredFeatures
}

export default class Project {
  public id: number;
  private features: any[] = [];
  private textIndex: string = '';
  static ignoreList = ['fid', 'date_added', 'change_type', 'status',
  'date_notified', 'date_technical_meeting', 'date_policy_meeting', 'comments'];

  constructor(id: number) {
    this.id = id;
  }

  static getFieldDifference(featureA, featureB) {
    let changeFields = []
    for (let property in featureA.properties) {
      if (featureA.properties[property] !== featureB.properties[property] &&
          Project.ignoreList.indexOf(property) == -1) {
        changeFields.push(property)
      }
    }
    return changeFields;
  }

  private hasHistory() {
    return (tipFilter(this.features).length > 1 ? 'hasHistory' : 'noHistory');
  }

  public getLatestFeature() {
    return this.features[0]
  }

  public getTableRows(expanded: boolean = false) {
    let features = tipFilter(this.features);
    features = features.map((feature, i) => {
          return {
              ...feature,
              properties: {
                ...feature.properties,
                rowClassAttribute: (i === 0) ?
                'latest ' + this.hasHistory() : 'history noHistory',
                ...this.getAllCellClass(this.features[i + 1], feature, expanded)
              }
            };
          });
    return (expanded ? features : [features[0]])
  }

  public getPresentationRows(
      meeting_type: 'technical_meeting' | 'policy_meeting',
      date: string) {
    let index: number = 0;
    for (let n in this.features) {
      let i = parseInt(n);
      if (this.features[i]['properties']['date_' + meeting_type] === date) {
        index = (index > i ? index : i)
      }
    }
    // it should return the row with the current meeting date and the one
    // latest row from previous meeting
    let features = this.features.slice(0, index + 3)
    features = features.map((feature, i) => {
          return {
              ...feature,
              properties: {
                ...feature.properties,
                rowClassAttribute: (i === 0) ?
                'latest ' + this.hasHistory() : 'history noHistory',
                ...this.getAllCellClass(this.features[i + 1], feature, true)
              }
            };
          });
    return features;
  }

  public getMemoRows(meeting_type: string, date: string) {
    let index: number = 0;
    for (let n in this.features) {
      let i = parseInt(n);
      if (this.features[i]['properties'][meeting_type] === date) {
        index = (index > i ? index : i)
      }
    }
    return this.features.slice(0, index + 2)
  }

  private getAllCellClass(previousFeature: any, currentFeature: any,
      expanded: boolean) {
    let allCellClasses = {};
    for (let cellClass in cellMap) {
      allCellClasses[cellClass] = this.getCellClass(
        previousFeature,
        currentFeature,
        cellMap[cellClass],
        expanded)
    }
    return allCellClasses
  }

  private getCellClass(previousFeature: any, currentFeature: any,
      property: string, expanded: boolean) {
    if (previousFeature === undefined || !expanded) return 'unchanged';
    return (previousFeature.properties[property] ===
      currentFeature.properties[property]) ?
      'unchanged' : 'changed';
  }

  public addFeature(feature: any) {
    this.features.push(feature);
  }

  public searchText(keywords: string) {
    return (this.textIndex.indexOf(keywords) != -1 ? true : false)
  }

  public createIndex(method: string = 'last') {
    if (method === 'last') {
      let latestFeature = this.getLatestFeature();
      for (let category in latestFeature.properties) {
        if (latestFeature.properties[category]) {
          this.textIndex = this.textIndex.concat(
            latestFeature.properties[category].toString().toLowerCase())
        }
      }
    }
  }

  public getLatestAttribute(attribute: string) {
    return this.features[0]['properties'][attribute]
  }

  public getChangeFields(method: string = 'latest', ignoreFields: string[] = []) {
    if (method === 'latest') {
      let history = this.features[this.features.length - 1]
      let latest = this.features[0]
      let changeFields = [];
      if (history === undefined) return [];
      for (let property in latest.properties) {
        if (latest.properties[property] !== history.properties[property] &&
            Project.ignoreList.indexOf(property) == -1) {
          changeFields.push(property)
        }
      }

      if (ignoreFields.length > 0) {
        for (let field of ignoreFields) {
          changeFields = changeFields.filter(f => f != field)
        }
      }

      return changeFields;
    }
  }

  public getPreviousAttribute(attribute: string) {
    return (this.features.length > 1 ?
      this.features[1]['properties'][attribute] :
      this.features[0]['properties'][attribute]
    )
  }

  public featureCount() {
    return this.features.length
  }
}
